import { render, staticRenderFns } from "./CooperationAgreement.vue?vue&type=template&id=c7e51496&scoped=true&"
import script from "./CooperationAgreement.vue?vue&type=script&lang=js&"
export * from "./CooperationAgreement.vue?vue&type=script&lang=js&"
import style0 from "./CooperationAgreement.vue?vue&type=style&index=0&id=c7e51496&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e51496",
  null
  
)

export default component.exports